import React from 'react'

export default function CreateButton(props) {
  return (
    <>            
        <button className='mr-4 rounded-xl bg-green-500 px-4 py-2 text-white hover:text-lg duration-300 ' onClick={()=>{props.onClick()}}>{props.text}</button>
    </>
  )
}
